import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
var Table = /*#__PURE__*/ function (_Component) {
    _inheritsLoose(Table, _Component);
    function Table() {
        return _Component.apply(this, arguments) || this;
    }
    var _proto = Table.prototype;
    _proto.render = function render() {
        var heads = [];
        this.props.head.forEach(function (element) {
            heads.push(/*#__PURE__*/ React.createElement("th", {
                key: element,
                className: "border-r border-black-primary px-2 md:px-8 last:border-r-0"
            }, element));
        });
        var body = [];
        this.props.data.forEach(function (subelement) {
            var tr = [];
            subelement.forEach(function (element) {
                tr.push(/*#__PURE__*/ React.createElement("td", {
                    key: element,
                    className: "border-r border-black-primary px-2 md:px-8 last:border-r-0",
                    dangerouslySetInnerHTML: {
                        __html: element
                    }
                }));
            });
            body.push(/*#__PURE__*/ React.createElement("tr", null, tr));
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: "font-ibm px-2 pb-12 "
        }, /*#__PURE__*/ React.createElement("div", {
            className: "container mx-auto"
        }, /*#__PURE__*/ React.createElement("hr", {
            className: "border-2 border-black my-10"
        }), this.props.title != "" ? /*#__PURE__*/ React.createElement("h3", {
            className: "text-4xl font-ibm font-bold mb-8 px-8"
        }, this.props.title) : null, /*#__PURE__*/ React.createElement("div", {
            className: "flex overflow-x-auto md:justify-center"
        }, /*#__PURE__*/ React.createElement("table", {
            className: "table-auto "
        }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", {
            className: "text-left"
        }, heads)), /*#__PURE__*/ React.createElement("tbody", null, body))), /*#__PURE__*/ React.createElement("hr", {
            className: "border-2 border-black my-10"
        })));
    };
    return Table;
}(Component);
export { Table as default };
